import { useContext } from 'react'
import { InternalContext } from '../../contexts/InternalContext'
import { useElementEventListener } from '../../../hooks/useElementEventListener'
import { useGetVisibleRatioPosition } from '../../hooks/useGetVisibleRatioPosition'
import { useChannelsElementRect } from './useChannelsElementRect'
import { CutterContext } from '../../contexts/CutterContext'
import { useVisiblePixelSize } from '../../hooks/useVisiblePixelSize'
import { useValidateVisibleRange } from '../../hooks/useValidateVisibleRange'

export function useChannelsPositionScrolling() {
  const { setVisibleRange } = useContext(CutterContext)
  const { containerElement, setZoom } = useContext(InternalContext)
  const getVisibleRatioPosition = useGetVisibleRatioPosition()
  const { width, left } = useChannelsElementRect()
  const pixelSize = useVisiblePixelSize()
  const validateVisibleRange = useValidateVisibleRange()

  useElementEventListener(containerElement, 'wheel', (event) => {
    event.preventDefault()

    const position = getVisibleRatioPosition((event.clientX - left) / width)

    if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
      setZoom((zoom) => zoom * (1 - event.deltaY / 200), position)
    } else {
      setVisibleRange(([from, to]) =>
        validateVisibleRange([from + pixelSize * event.deltaX, to + pixelSize * event.deltaX]),
      )
    }
  })
}
